import types from "./mutation-types"
import publicActions from "../publicModule/publicActions"
export default {
  ...publicActions(types)
}
